/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsPreview,
    MelcoModelsPreviewFromJSON,
    MelcoModelsPreviewFromJSONTyped,
    MelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsAlphabetCollectionDefaultAlphabet
 */
export interface MelcoModelsAlphabetCollectionDefaultAlphabet {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsAlphabetCollectionDefaultAlphabet
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsAlphabetCollectionDefaultAlphabet
     */
    name?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsPreview>}
     * @memberof MelcoModelsAlphabetCollectionDefaultAlphabet
     */
    previews?: Array<MelcoModelsPreview> | null;
}

export function MelcoModelsAlphabetCollectionDefaultAlphabetFromJSON(json: any): MelcoModelsAlphabetCollectionDefaultAlphabet {
    return MelcoModelsAlphabetCollectionDefaultAlphabetFromJSONTyped(json, false);
}

export function MelcoModelsAlphabetCollectionDefaultAlphabetFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsAlphabetCollectionDefaultAlphabet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(MelcoModelsPreviewFromJSON)),
    };
}

export function MelcoModelsAlphabetCollectionDefaultAlphabetToJSON(value?: MelcoModelsAlphabetCollectionDefaultAlphabet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(MelcoModelsPreviewToJSON)),
    };
}


